import Home from './pages/Home';
import './styles/redesign.css';

function App() {
  return (
     <>
     <Home/>
     </>
  );
}

export default App;
